import { Modal      } from "react-bootstrap";
import { Button     } from "./Controls/Button";
import { HeaderText } from "./Controls/HeaderText";
import { PaymentMethodResp } from "./Data/ApiTypes";

interface DeletePaymentMethodModalProps {
    method:   PaymentMethodResp;
    show:     boolean;
    setShow:  ( show: boolean ) => void;
    onDelete: ( pm: PaymentMethodResp ) => void;
    used:     boolean;
}

export function DeletePaymentMethodModal( { method, show, setShow, used, onDelete }: DeletePaymentMethodModalProps ) {
    return (
        <Modal centered show={show} onEscapeKeyDown={() => setShow(false)}>
            <Modal.Header>
                <HeaderText>Delete Payment Method</HeaderText>
            </Modal.Header>
            <Modal.Body className="text-center">
                <div className="mb-4">
                    {used ? (
                        <div className="text-danger-light">
                            This payment method is linked to an active plan and <strong>cannot be deleted.</strong>
                            <br />
                            Please update the plan with a different payment method before proceeding.
                        </div>
                    ) : (
                        <div>
                            This payment method is not in use and may be safely deleted.
                        </div>
                    )}
                </div>

                <div className="d-flex justify-content-center gap-2">
                    <Button className="w-50" onClick={() => setShow(false)}>
                        Cancel
                    </Button>
                    {!used && (
                        <Button
                            className="w-50 bg-danger text-white border-danger"
                            onClick={() => {
                                setShow(false);
                                onDelete(method);
                            }}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}